import React, { Fragment, useState, useEffect } from "react";
import PageTitle from "../container/layouts/PageTitle";
import {
  Row,
  Col,
  Card,
  Table,
  Badge,
  Dropdown,
  ProgressBar,
  Button,
  Modal,
  Form
} from "react-bootstrap";
import PerfectScrollbar from "react-perfect-scrollbar";
import { useHistory, Link } from "react-router-dom";
import axios from "axios";
import { Progress } from "reactstrap";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getInstance } from '../config/token';
import Spinner from 'react-bootstrap/Spinner'
import BootstrapTable from "react-bootstrap-table-next";
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
  PaginationTotalStandalone
} from 'react-bootstrap-table2-paginator';
import 'react-phone-number-input/style.css'
import PhoneInput from 'react-phone-number-input'
import { getCountries, getCountryCallingCode } from 'react-phone-number-input/input'
import AddContactPopup from "../contact/addContactPopup";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import { makeStyles } from "@material-ui/core/styles";
import AddSmsPopup from "./addSmsPopup";

// const useStyles = makeStyles({
//   paper: {
//     fontWeight : "700",
//     border: "1px solid #3D455A !important",
//     borderRadius: "0.75rem !important"
//   }
// });


const prefix = process.env.REACT_APP_API_URL

const defaultPageSize = 100
const defaultSortOrder = 'desc'
const defaultSortKey = 'id'

const sizePerPageList = [ {
  text: '10', value: 10
}, {
  text: '25', value: 25
}, {
  text: '50', value: 50
}, {
  text: '75', value: 75
}, {
  text: '100', value: 100
} ]

/// imge

const SmsList = () => {
  const history = useHistory()
  const [ show, setShow ] = useState(false);
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [message, setmessage] = useState("");
  const [order_id, setOrderId] = useState("");
  const [file, setFile] = useState("");
  const [loaded, setLoader] = useState(0);
  const [fileName, setFileName] = useState([]);
  const [cameraModal, setCameraModal] = useState(false);
  const [newEvent, setNewEvent] = useState(false);
  const [errMsg, setErrMsg] = useState("");
  const [ticketListSms, setTicketListSms] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filePath, setFilePath] = useState([]);
  const[type, setType] = useState(0)
  const[userType, setUserType] = useState(0)
  const[status, setStatus] = useState("")
  const[statusFilter, setStatusFilter] = useState("0")
  const [loadingList, setLoadingList] = useState(false);
  const[searchTicketSms, setSearchTicketSms] = useState("")
  const [country, setCountry] = useState("US")
  const [countryCode, setCountryCode] = useState("1")
  // const[openCount, setOpenCount] = useState(0)
  // const[pendingCount, setPendingCount] = useState(0)
  // const[closedCount, setClosedCount] = useState(0)
  // const[spamCount, setSpamCount] = useState(0)
  const[columneDisplayField, setColumneDisplayField] = useState("")
  const[columneDisplayValue, setColumneDisplayValue] = useState(false)
  const[currentPage, setCurrentPage] = useState(1)
  const[pageSize, setPageSize] = useState(defaultPageSize)
  const[totalCount, setTotalCount]=useState(0)
  const[sortKey, setSortKey] = useState(defaultSortKey)
  const[sortType, setSortType]=useState(defaultSortOrder)
  const[randomValue, setRandomValue] = useState(0)
  const[selected, setSelected] = useState([])
  const[modalStatus, setModalStatus] = useState(false)
  const[statusSmsThreadId, setStatusSmsThreadId] = useState("")
  const[statusSmsThreadType, setStatusSmsThreadType] = useState("")
  const[userTypeFilter, setUserTypeFilter] = useState("0")
  const[rentCount, setRentCount] = useState(0)
  const[supportCount, setSupportCount] = useState(0)
  const[showContactPopup, setShowContactPopup] = useState(false)
  const[contactList, setContactList] = useState([])
  const [phoneInputDisable, setPhoneInputDisable] = React.useState(false)

  useEffect( () => {
    getTicketListSms()
    
 }, [searchTicketSms, currentPage, pageSize, sortType, sortKey, statusFilter]);

// const classes = useStyles();

const columns = [
  {
    dataField: "thread_id",
    text: "#",
    modify : false,
    // sort: true,
  },
  {
    dataField: "sms_user_name",
    text: "User",
    hidden : localStorage.getItem("sms_user_name") == null || localStorage.getItem("sms_user_name") == 'null' ? false : JSON.parse(localStorage.getItem("sms_user_name")),
    modify : true,
    // sort: true
  },
  {
    dataField: "phone_number2_id",
    text: "Ph No. 2",
    hidden : localStorage.getItem("phone_number2_id") == null || localStorage.getItem("phone_number2_id") == 'null' ? true : JSON.parse(localStorage.getItem("phone_number2_id")),
    modify : true,
  },
  {
    dataField: "sms_last_message",
    text: "Message",
    hidden : localStorage.getItem("sms_last_message") == null || localStorage.getItem("sms_last_message") == 'null' ? true : JSON.parse(localStorage.getItem("sms_last_message")),
    modify : true,
  },
  {
    dataField: "sms_column_created",
    text: "Date",
    hidden : localStorage.getItem("sms_column_created") == null || localStorage.getItem("sms_column_created") == 'null' ? true : JSON.parse(localStorage.getItem("sms_column_created")),
    modify : true,
    sort : true
  },
]

// const mapticketSmsData = () => {
  var ticketSmsData = []
 ticketListSms.map(function (item, i) {
    return (
      ticketSmsData.push({
        thread_id : <div>
            <div>
              <Link to={`/sms/${item.id}`}>
                <strong>{process.env.REACT_APP_SMS_PREFIX + item.id}</strong>
              </Link>
            </div>
          <div>
        <Badge variant="success light" style = {{cursor : "pointer"}} className={item.status == 0 ?"status-open" : item.status == 1 ? "status-closed" : "status-pending"}>
          {item.status == 0
            ? 
            <span onClick={() => openStatusModal(item.id, 0)}>
                Pending
              </span>
            : item.status == 1? 
            <span onClick={() => openStatusModal(item.id, 1)}>
              Completed
            </span>
            : ""
          }
        </Badge>
        </div>
        </div>,
        sms_user_name : item.user ? item.user.first_name && item.user.last_name ? item.user.first_name +" "+ item.user.last_name : item.user.first_name ? item.user.first_name : item.user.last_name ? item.user.last_name : "-" : '-',
      phone_number2_id :<div>
        <span style={{display : "block", marginBottom : item.phoneNoTwo && item.phoneNoTwo.first_name ? "5px" : "0px"}}>{item.phoneNoTwo && item.phoneNoTwo.first_name ? item.phoneNoTwo.first_name + " " + item.phoneNoTwo.last_name: '' }</span>
        <span style={{display : "block"}}>{item.phoneNoTwo && item.phoneNoTwo.phone ? item.phoneNoTwo.phone : '-' }</span>
      </div>,
      // item.phoneNoTwo && item.phoneNoTwo.phone ? item.phoneNoTwo.phone : '-',
      sms_last_message : item.user_support_sms_messages && item.user_support_sms_messages.length && item.user_support_sms_messages[0].message ? item.user_support_sms_messages[0].message : "Attachment",
      sms_column_created : item.user_support_sms_messages && item.user_support_sms_messages.length ? `${new Date(item.user_support_sms_messages[0].createdAt).toLocaleString('en-US', { timeZone: 'America/New_York' })}` : "-",
      id : item.id,
      is_new_reply : item.is_new_reply
      })
    ) 
  })

  // const setPhoneNumber = (phone) => {
  //   if(phone != undefined){
  //     setPhone(phone)
  //   }
  // }

  // const setCountryData = (country) => {
  //   if(country != undefined){
  //     setCountry(country)
  //     setCountryCode(getCountryCallingCode(country))
  //   }
  // }

const openStatusModal = (threadId, statusType) => {
  if(localStorage.getItem("userType") == 1 || localStorage.getItem("userType") == 2){
    setModalStatus(true)
    setStatusSmsThreadId(threadId)
    setStatusSmsThreadType(statusType)
  }
}

const onStatusChange = (e, smsIds) => {
  setStatus(e.target.value)
}

const returnList = () => {
    return columns.map((column) => (
      column.modify?
      <Form.Check
        type="checkbox"
        key={column.dataField}
        inline
        label={column.text}
        id={column.dataField}
        //aria-pressed={(column.toggle) ? "true" : "false"}
        checked={column.hidden}
        aria-checked={column.hidden ? "true" : "false"}
        // onChange = {() => onColumnToggle(column.dataField)}
        onClick={() => showHideColumn(column.dataField, column.hidden)}
        // onClick={() => onColumnToggle(column.dataField)}
      /> : ""
    ));
};

const showHideColumn = (field,value) =>{
  if(field != 'id'){
    let fieldValue = (JSON.parse(localStorage.getItem(field)) == null || JSON.parse(localStorage.getItem(field)) == 'null' ? value : JSON.parse(localStorage.getItem(field)))
    localStorage.setItem(field, !fieldValue)
    setColumneDisplayValue(!columneDisplayValue)
    setColumneDisplayField(field)
    setRandomValue(Math.floor(Math.random() * 1000)+1)
  }
}

//  const getTicketCount = () => {
//   let config = getInstance('GET', `/api/get_ticket_list_count`, {});
//   axios(config)
//   .then((res) => {
//     if(res.data && res.data.statusCount && res.data.statusCount.length){
//       for(let i=0; i < res.data.statusCount.length; i++){
//         if(!res.data.statusCount[i].status || res.data.statusCount[i].status == 'false'){
//           setOpenCount(res.data.statusCount[i].ticketCount)
//         } 
//         if((res.data.statusCount[i].status || res.data.statusCount[i].status == 'true') && (res.data.statusCount[i].status != 2 && res.data.statusCount[i].status != '2' && res.data.statusCount[i].status != 3 && res.data.statusCount[i].status != '3')){
//           setClosedCount(res.data.statusCount[i].ticketCount)
//         } 
//         if(res.data.statusCount[i].status == 2 || res.data.statusCount[i].status == '2'){
//           setPendingCount(res.data.statusCount[i].ticketCount)
//         }
//         if(res.data.statusCount[i].status == 3 || res.data.statusCount[i].status == '3'){
//           setSpamCount(res.data.statusCount[i].ticketCount)
//         }
//       }
//     }
//     if(res.data && res.data.typeCount && res.data.typeCount.length){
//       for(let i=0; i < res.data.typeCount.length; i++){
//         if(res.data.typeCount[i].user_type == 3 || res.data.typeCount[i].user_type == '3'){
//           setRentCount(res.data.typeCount[i].ticketTypeCount)
//         } 
//         if(res.data.typeCount[i].user_type == 4 || res.data.typeCount[i].user_type == '4'){
//           setSupportCount(res.data.typeCount[i].ticketTypeCount)
//         } 
       
//       }
//     }
//   })
//   .catch((err) => {
//     console.log("Error", err)
//   })
// }


 const getTicketListSms = () => {
   setLoadingList(true)
   let reqObj = {
     status : statusFilter,
     search : searchTicketSms,
     page : currentPage,
     size : pageSize,
     sort : sortType,
     key : sortKey,
    //  user : userTypeFilter
   }
   let config = getInstance('POST', `/api/get_sms_list`, reqObj);
  axios(config)
  .then((res) => {
    setTotalCount(res.data.count ? res.data.count : 0)
    setTicketListSms(res.data.rows ? res.data.rows : [])
    setLoadingList(false)
  })
  .catch((err) => {
    setLoadingList(false)
  })
 }

  // const createSms = () => {
  //   // setErrMsg("")
  //   let errFlag = false;
  //   if (phone == "") {
  //     errFlag = true;
  //     toast.error("phone is required.", {
  //       position: "top-right",
  //     });
  //     // setErrMsg("Title is required.");
  //   } else if (phone.length < 4) {
  //     errFlag = true;
  //     toast.error("Phone can not be less than 4 digit.", {
  //       position: "top-right",
  //     });
  //     // setErrMsg("Title can not be more than 255 characters.");
  //   } else if (message == "") {
  //     errFlag = true;
  //     toast.error("Message is required.", {
  //       position: "top-right",
  //     });
  //     // setErrMsg("Message is required.");
  //   } else if (message.length > 5000) {
  //     errFlag = true;
  //     toast.error("Message can not be more than 5000 characters.", {
  //       position: "top-right",
  //     });
  //     // setErrMsg("Message can not be more than 5000 characters.");
  //   }

  //   if (!errFlag) {
  //     let requestObj = {
  //       phone: phone,
  //       message: message,
  //       file : filePath,
  //       code : countryCode,
  //       country : country
  //     };

  //     // if(localStorage.getItem("userType") == 1 || localStorage.getItem("userType") == 2){
  //     //   if (email == "") {
  //     //     toast.error("Email is required.", {
  //     //       position: "top-right",
  //     //     });
  //     //     return
  //     //   } else{
  //     //     // if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
  //     //       requestObj.email = email
  //     //     // } else{
  //     //     //   toast.error("You have entered an invalid email address!", {
  //     //     //     position: "top-right",
  //     //     //   });
  //     //     //   return
  //     //     // }
  //     //   }
  //     //   if (userType == 0) {
  //     //     toast.error("Please select user.", {
  //     //       position: "top-right",
  //     //     });
  //     //     return
  //     //   } 
  //     //   requestObj.userType = userType
  //     // }
  //     setLoading(true)
  //     let config = getInstance('POST', `/api/create_sms`, requestObj);
  //     axios(config)
  //       // .post(prefix + "/api/create_ticket", requestObj)
  //       .then((res) => {
  //         setNewEvent(false);
  //         setFileName([]);
  //         setPhone("");
  //         setmessage("");
  //         // setOrderId("");
  //         setFile("");
  //         getTicketListSms()
  //         setFilePath([])
  //         // getTicketCount()
  //         setSelected([])
  //         setLoading(false)

  //         toast.success("Sms Thread Successfully Created", {
  //           position: "top-right",
  //         });
  //       })
  //       .catch((err) => {
  //         setLoading(false)
  //         let msg = "Something went wrong!"
  //         // setLoading(false)
  //         if(err.response && err.response.data && err.response.data.message){
  //           msg = err.response.data.message
  //         }
  //         toast.error(msg, {
  //           position: "top-right",
  //         });
  //       });
  //   }
  //   // else {
  //   //   toast.error(errMsg, {
  //   //     position: "top-right",
  //   //   });
  //   // }
  // };


//   const maxSelectFile=(event)=>{
//     let files = event.target.files // create file object
//         if (files.length > 3) { 
//           //  const msg = 'Only 3 images can be uploaded at a time'
//            event.target.value = null // discard selected file
//            toast.error("Only 2 files can be uploaded at a time.", {
//             position: "top-right",
//           });
//           return false;
 
//       }
//     return true;
 
//  }

//  const checkFileSize=(event)=>{
//   let files = event.target.files
//   let size = 5000000
//   let err = ""; 
//   for(var x = 0; x<files.length; x++) {
//   if (files[x].size > size) {
//    err += files[x].type+' is too large, please pick a smaller file\n';
//  }
// };
// if (err !== '') {
//   event.target.value = null
//   toast.error(err, {
//     position: "top-right",
//   });
//   return false
// }

// return true;

// }

//   const onFileChange = (e) => {
//     // this.setState({ file: e.target.files[0] },() => {
//       var mulFiles = e.target.files
//       if(maxSelectFile(e) && checkFileSize(e)){ 
//         setLoading(true)
//         setFile(mulFiles);
//         const data = new FormData();
//         for(var x = 0; x < mulFiles.length; x++) {
//           data.append('file', mulFiles[x])
//       }
//         // data.append("file", e.target.files[0]);
//         let config = getInstance('POST', `/api/upload`, data);
//         // axios(config,
//         //   onUploadProgress: (ProgressEvent) => {
//         //     console.log("ProgressEvent", ProgressEvent)
//         //     setLoader((ProgressEvent.loaded / ProgressEvent.total) * 100);
//         //   },
//         // )
//         axios.post(config.url, config.data,  {
//             headers: config.headers,
//             onUploadProgress: (ProgressEvent) => {
//               setLoader((ProgressEvent.loaded / ProgressEvent.total) * 100);
//             },
//           })
    
//           .then((res) => {
//             // then print response status
//             setLoader(0);
//             setCameraModal(false);
//             let filePathArray = filePath
//             let fName = fileName
//             for(let i = 0; i < res.data.length; i++){
//               // setFileName(res.data[i] && res.data[i].filename ? res.data[isNaN].filename : "");
//               let filepath = prefix + '/' + res.data[i].path
//               filePathArray.push(filepath)
//               // setFilePath(filepath)
//               fName.push(res.data[i].filename)
//             }
//             setFilePath(filePathArray)
//             setFileName(fName)
//             setLoading(false)
//           })
//           .catch((err) => {
//             setLoading(false)
//             console.log(err)
//           });
//       }
//   };

const selectType = (e) => {
  setType(e.target.value)
}
const selectUserType = (e) => {
  setUserType(e.target.value)
}

const changeStatus = (e, smsIds, statusType="multiple") => {
  setLoading(true)
  // setStatus(e.target.value)
  let requestObj = {
    status: statusType == "single" ? e : e.target.value,
    threadIds: smsIds,
  };
  let config = getInstance('POST', `/api/update_sms_status`, requestObj);
  axios(config)
    // .post(prefix + "/api/create_ticket", requestObj)
    .then((res) => {
      setLoading(false)
      toast.success("Sms status changed", {
        position: "top-right",
      });
      getTicketListSms()
      // getTicketCount()
      setSelected([])
      setStatusSmsThreadId("")
      setStatusSmsThreadType("")
      setModalStatus(false)
    })
    .catch((err) => {
      let message = "Something went wrong!"
      setLoading(false)
      if(err.response && err.response.data && err.response.data.message){
        message = err.response.data.message
      }
      toast.error(message, {
        position: "top-right",
      });
      console.log(err)
    });
} 

const changeStatusFilter = (e) => {
  setStatusFilter(e.target.value)
  setPageSize(defaultPageSize)
  setCurrentPage(1)
  setSelected([])
}

const changeUserFilter = (e) => {
  setUserTypeFilter(e.target.value)
  setPageSize(defaultPageSize)
  setCurrentPage(1)
  setSelected([])
}

const setSearchKey = (e) => {
  setSearchTicketSms(e.target.value)
  setPageSize(defaultPageSize)
  setCurrentPage(1)
  setSelected([])
}

const openTicketModel = () => {
  setNewEvent(true)
  // setFileName([])
}

const contactPopup = () => {
  setShowContactPopup(true)
}

const closeContactPopup = () => {
  setShowContactPopup(false)
}

const viewContact = () => {
  history.push("/contact-list")
}

const handleEditorChange = (content, editor) => {
  console.log("Content was updated:", content);
  setmessage(content)
};

const rowClasses = (row, rowIndex) => {
    if(row && row.is_new_reply ){
      return 'ticket-highlight';
    } else {
      return ''
    }
};

const handleTableChange = (type, { page, sizePerPage, sortField, sortOrder }) => {
  if(type == 'pagination'){
    if(sizePerPage != pageSize){
      setPageSize(sizePerPage)
      setCurrentPage(1)
    } else {
      setCurrentPage(page)
    }
    setSelected([])
  } else if(type == 'sort'){
    setSortType(sortOrder)
    setSortKey(sortField)
    setPageSize(defaultPageSize)
    setCurrentPage(1)
    setSelected([])
  }
}

const selectRow = {
  mode: 'checkbox',
  // clickToSelect: localStorage.getItem("userType") == 1 || localStorage.getItem("userType") == 2 ? true : false,
  hideSelectColumn: localStorage.getItem("userType") == 1 || localStorage.getItem("userType") == 2 ? false : true,
  selected: selected,
  onSelect: (row, isSelect, rowIndex, e) => {
    if (isSelect) {
      setSelected([...selected, row.id])
    } else {
      setSelected(selected.filter(x => x !== row.id))
    }
  },
  onSelectAll: (isSelect, rows, e) => {
    const ids = rows.map(r => r.id);
    if (isSelect) {
      setSelected(ids)
    } else {
      setSelected([])
    }
  }
};

  // const onInputChange = (event, value, reason) => {
  //   if (value) {
  //     getData(value);
  //   } else {
  //     setContactList([]);
  //   }
  // };

  // const selectContact = (value) => {
  //   if(value){
  //     setPhoneInputDisable(true)
  //     setPhone(value.phone)
  //     setCountry(value.country)
  //     setCountryCode(value.code)
  //   } else {
  //     setPhoneInputDisable(false)
  //   }
  // }

  // const getData = (searchTerm) => {
  //   let reqObj = {
  //     search : searchTerm,
  //   }
  //   let config = getInstance('POST', `/api/search_contacts`, reqObj);
  //    axios(config)
  //    .then((res) => {
  //      let contact = []
  //      if(res.data && res.data.rows){
  //        for(let i=0; i < res.data.rows.length;i++){
  //          contact.push({id :  res.data.rows[i].id, label : res.data.rows[i].first_name && res.data.rows[i].last_name ? res.data.rows[i].first_name + " " + res.data.rows[i].last_name + " : " + res.data.rows[i].phone : res.data.rows[i].phone, phone : res.data.rows[i].phone, code : res.data.rows[i].calling_code, country : res.data.rows[i].country_code})
  //        }
  //      }
  //      setContactList(contact)
  //    })
  //    .catch((err) => {
  //    })
  // };

  const closeSmsPopup = () => {
    setNewEvent(false)
    // setPhone("")
    // setCountry("US")
    // setCountryCode("1")
    // setFileName([])
  }
  return (
    <Fragment>
      {/* <PageTitle activeMenu="Table" motherMenu="Bootstrap" /> */}
      {/* <div className="deznav"> */}
      <PerfectScrollbar className="deznav-scroll">
        <div style={{ display: "inline" }}>
          <select
            className="form-control form-border-color"
            style={{
              width: "fit-content",
              display: "inline",
              marginBottom: "1rem",
            }}
            name="filter"
            id="filter"
            defaultValue={statusFilter}
            onChange={(e) => changeStatusFilter(e)}
          >
            <option value="4">All Status</option>
            <option value="0">Pending</option>
            <option value="1">Completed</option>
          </select>
          {/* <React.Fragment>
          {localStorage.getItem("userType") == 1 ||
          localStorage.getItem("userType") == 2 ?       
          <select
            className="form-control form-border-color"
            style={{
              marginLeft: "5px",
              width: "fit-content",
              display: "inline",
              marginBottom: "1rem",
            }}
            name="user_filter"
            id="user_filter"
            defaultValue={userTypeFilter}
            onChange={(e) => changeUserFilter(e)}
          >
            <option value="0">All User</option>
            <option value="1">Admin</option>
            <option value="2">Employee</option>
            <option value="3">Customer</option>
            <option value="4">Provider</option>
          </select> : ""}
          </React.Fragment>   */}

          <input
            type="text"
            name="title"
            style={{
              marginLeft: "5px",
              width: "fit-content",
              display: "inline",
              marginBottom: "1rem",
            }}
            className="form-control form-border-color"
            maxLength={255}
            placeholder="Search Here..."
            value={searchTicketSms}
            onChange={(e) => setSearchKey(e)}
          />
          {/* <span class="badge badge-sm light badge-primary status-count-span status-open">
            Open : {openCount}
          </span>
          <span class="badge badge-sm light badge-primary status-count-span status-pending">
            Pending : {pendingCount}
          </span>
          <span class="badge badge-sm light badge-primary status-count-span status-closed">
          Completed : {closedCount}
          </span>
          <span class="badge badge-sm light badge-primary status-count-span status-spam">
          Spam : {spamCount}
          </span> */}
           <Button
            as="a"
            // className="add-menu-sidebar"
            style={{ float: "right", marginBottom: "1rem", backgroundColor:"#3D455A ", borderColor:"#3D455A" }}
            data-toggle="modal"
            data-target="#addOrderModalside"
            onClick={() => openTicketModel()}
          >
            + New SMS
          </Button>

          
          <Button
            as="a"
            // className="add-menu-sidebar"
            style={{ float: "right", marginBottom: "1rem", marginRight: "10px" }}
            data-toggle="modal"
            data-target="#addOrderModalside"
            onClick={() => contactPopup()}
          >
            + Contact
          </Button>

          <Button
            as="a"
            // className="add-menu-sidebar"
            style={{ float: "right", marginBottom: "1rem", marginRight: "10px" }}
            data-toggle="modal"
            data-target="#addOrderModalside"
            onClick={() => viewContact()}
          >
            View Contacts
          </Button>
          {
          showContactPopup ? 
          <AddContactPopup contactId = {null} closeContactPopup = {closeContactPopup} type="sms" contactPopupShow = {showContactPopup} />
          :""
        }
         {
          newEvent ? 
          <AddSmsPopup closeSmsPopup = {closeSmsPopup} type="sms" newEvent = {newEvent} getTicketListSms = {getTicketListSms} />
          :""
        }

         
        </div>

        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={true}
          newestOnTop
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
        <Modal
          show={modalStatus}
          // onHide={() => this.setState({ cameraModal: false })}
          className="modal fade"
          id="statusModal"
        >
        <div className="">
            <div className="modal-header">
              <h5 className="modal-title">Update Status - {process.env.REACT_APP_SMS_PREFIX + statusSmsThreadId}</h5>
              <Button
                variant=""
                type="button"
                className="close"
                data-dismiss="modal"
                onClick={() => setModalStatus(false)}
              >
                <span>×</span>
              </Button>
            </div>
            <div className="modal-body">
              <form
                className="comment-form"
                onSubmit={(e) => {
                  e.preventDefault();
                  // setNewEvent(false);
                }}
              >
                <div>
                  <div className="form-group">
                    <div className="form-group">
                      <label className="text-black font-w500">
                        Select Type
                      </label>
                      <select
                        className="form-control form-border-color"
                        // style={{ width: "fit-content" }}
                        name="type"
                        id="type"
                        defaultValue={statusSmsThreadType}
                        onChange={(e) => onStatusChange(e)}
                      >
                        <option value="0">Pending</option>
                        <option value="1">Completed</option>
                      </select>
                    </div>
                  </div>
                  <div className="form-group" style={{ textAlign: "center" }}>
                    <input
                      disabled={loading}
                      type="submit"
                      value="Update Status"
                      className="btn btn-primary"
                      onClick={() => changeStatus(status, [statusSmsThreadId], "single")}
                    />
                  </div>
                </div>
              </form>
            </div>
          </div>
        </Modal>

       
      </PerfectScrollbar>
      {/* </div> */}
      <Row>
        <Col lg={12}>
          <Card className="form-border-color">
            <Card.Header style={{borderBottom : "0px", paddingBottom : "0.5rem"}}>
              <Card.Title>SMS List</Card.Title>
              <Card.Title>
              <Button
            as="a"
            // className="add-menu-sidebar"
            // style={{ float: "right", marginBottom: "1rem" }}
            // data-toggle="modal"
            // data-target="#addOrderModalside"
            // onClick={() => openTicketModel()}
          >
            {process.env.REACT_APP_FROM_PHONE_NUMBER}
          </Button>
                </Card.Title>
              <Card.Title></Card.Title>
            </Card.Header>
            {/* <div className="ticket-type-count-div">
              {localStorage.getItem("userType") == 1 || localStorage.getItem("userType") == 2 ? 
              <React.Fragment>
              <span class="badge badge-sm light badge-primary status-count-span rent-count">
                Rent : {rentCount}
              </span>
              <span class="badge badge-sm light badge-primary status-count-span support-count">
                Support : {supportCount}
              </span></React.Fragment> : ""}
              </div> */}
            <Card.Body style={{paddingBottom : "1.5rem"}}>
              <div>{columneDisplayValue}</div>
              {loadingList ? (
                <div
                  style={{
                    textAlign: "center",
                    width: "100%",
                    position: "absolute",
                    marginBottom: "10px",
                  }}
                >
                  <Spinner animation="border" role="status">
                    <span className="visually-hidden"></span>
                  </Spinner>
                </div>
              ) : ticketListSms.length > 0 ? (
                    <div>
                      <Dropdown style={{display : "inline-block"}} show={show}>
                        <Dropdown.Toggle
                          onClick={() => setShow(!show)}
                          variant="success"
                          id="dropdown-basic"
                        >
                          Show/Hide
                        </Dropdown.Toggle>

                        <Dropdown.Menu className="dropdown-custom">
                          {returnList()}
                        </Dropdown.Menu>
                      </Dropdown>
                      <div style={{display : "inline-block", paddingLeft : "1rem"}}>
                    {(localStorage.getItem("userType") == 1 || localStorage.getItem("userType") == 2) && selected.length > 0 ?
                        <select
                      className="form-control form-border-color"
                      style={{
                        height : "auto"
                      }}
                      name="type"
                      id="type"
                      defaultValue={""}
                      onChange={(e) => changeStatus(e, selected)}
                    >
                      <option value="" disabled>Change Status</option>
                      <option disabled = {statusFilter == 0 ? true : null} value="0">Pending</option>
                      <option disabled = {statusFilter == 1 ? true : null} value="1">Completed</option>
                    </select>
                  :""}
                  </div>
                      <hr />
                      <BootstrapTable
                      remote
                        className="table-responsive"
                        keyField="id"
                        data={ticketSmsData}
                        columns={columns}
                        pagination={ paginationFactory({ page : currentPage, sizePerPage : pageSize, totalSize:totalCount, paginationSize : 3, sizePerPageList : sizePerPageList }) }
                        rowClasses={ rowClasses }
                        onTableChange={ handleTableChange }
                        selectRow={ selectRow }
                      />
                    </div>
              ) : (
                <div
                  style={{
                    textAlign: "center",
                    width: "100%",
                    position: "absolute",
                    marginBottom: "10px",
                  }}
                >
                  <span style={{ fontWeight: "700" }}>{"🎉 No New SMS."}</span>
                </div>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Fragment>
  );
};

export default SmsList;
